import httpClient from "../api/httpClient";
import { parseError } from "./shared";

export const uploadFile = async ({
  file,
  fields = {},
  onProgress = null,
  cancelToken = null,
}) => {
  try {
    const formData = new FormData();

    // file
    formData.append("document", file);

    // dynamic fields (tenant_id, message_id, etc.)
    Object.entries(fields).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    });

    const response = await httpClient.post("upload-file-to-s3", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      cancelToken,
      onUploadProgress: (event) => {
        if (!event.total) return;
        const progress = Math.round((event.loaded * 100) / event.total);
        onProgress?.(progress);
      },
    });

    //@ts-ignore
    return response?.url || "";
  } catch (error) {
    parseError(error, true);
    throw error;
  }
};
